export default {
    data() {
        return {
            pageCode: 1,
            isPageLoading: true,
        };
    },
    methods: {
        load(tasks) {
            this.isPageLoading = true;
            return Promise.all(tasks).then((results) => results).catch((res) => {
                this.pageCode = res.data && res.data.code === 0 ? 0 : -1;
            }).finally(() => {
                this.isPageLoading = false;
            });
        },
        loadPage() {
            if (this.loadPageData) {
                return this.load([this.loadPageData()]);
            }
            return Promise.resolve();
        },
    },
};
